module.exports = __webpack_public_path__ + "static/media/de.b55ae913.svg";